// MÃ NỘI BỘ → CHỮ NGƯỜI ĐỌC (đợt B3, 08/10/2026). MỘT chỗ duy nhất cho: mã bước ("dang_bai_nhom"), khoá tham số ("tu_phut"), mã nhánh ("duong-n4"),
// múi giờ ("Asia/Ho_Chi_Minh"). Người dùng không bao giờ phải thấy mã máy: mã đã biết → tên tiếng Việt viết tay; mã lạ → dịch từng từ (bảng TU);
// từ lạ nữa → bỏ dấu gạch dưới (KHÔNG trả mã nguyên dạng). Thuần — không DOM, không mạng; dùng chung cho máy chủ, trang web và bot.
import { NHAN_THAM_SO } from "./ban-do";

/** Tên viết tay cho bước phụ / bước dùng chung nhiều thao tác (cũng là bảng tên chung của GET /api/ten-buoc). */
export const TEN_BUOC_VI: Record<string, string> = {
  cham_lien_quan: "AI chấm bài có liên quan",
  loc_lien_quan: "Lọc bài liên quan",
  bo_da_lam: "Bỏ mục đã làm",
  chi_da_xem: "Chỉ giữ mục đã xem",
  soan: "AI soạn câu",
  dang_binh_luan: "Đăng bình luận",
  soan_tra_loi: "AI soạn câu trả lời",
  gui_tra_loi: "Gửi câu trả lời",
  soan_bai: "AI soạn bài",
  tim_bai: "Tìm bài",
  lay_bai: "Tìm bài",
  tim_kiem: "Tìm video",
  lay_danh_sach: "Lấy danh sách kết quả",
  mo_bai: "Mở bài",
  chon_bai: "Chọn bài để làm",
  chon_video: "Chọn video để làm",
  thich_bai: "Thích bài",
  thich_bl: "Thích bình luận",
  nghi: "Nghỉ",
  lay_binh_luan: "Đọc bình luận",
  loc_binh_luan: "Lọc bình luận",
  mo_binh_luan: "Mở khu bình luận",
  lay_tai_khoan: "Đọc tên tài khoản",
  luot_xem_video: "Lướt xem video",
  mo_video_luot: "Mở video để xem",
  xem_video_luot: "Xem video",
  thich_video_luot: "Thích video khi lướt",
  mo_video_xem: "Mở video để xem",
  // đợt B3: những mã người dùng thấy lộ ở Thống kê / Chờ duyệt / Sổ kinh nghiệm / Việc đã làm
  dang_bai_x: "Đăng bài lên X",
  dang_bai: "Đăng bài",
  dang_bai_nhom: "Đăng bài vào nhóm",
  tham_gia_nhom: "Tham gia nhóm",
  tim_nhom: "Tìm nhóm",
  loc_bai_viet: "Lọc bài viết",
  loc_nhom_chua_tham_gia: "Lọc nhóm chưa tham gia",
  chon_bai_2: "Chọn bài để làm (lần 2)",
};

/** Từ (đã bỏ dấu, chữ thường) → từ tiếng Việt. Cụm từ ghép đứng ở CUM (khớp trước). */
const TU: Record<string, string> = {
  bai: "bài", tim: "tìm", tu: "từ", video: "video", lay: "lấy", bl: "bình luận", tt: "TikTok", mo: "mở", rd: "Reddit", kenh: "kênh", soan: "soạn",
  minh: "mình", tra: "trả", loi: "lời", menu: "menu", bo: "bỏ", xem: "xem", gui: "gửi", dang: "đăng", x: "X", trang: "trang", nick: "nick",
  luot: "lướt", doc: "đọc", thich: "thích", so: "số", ph: "phản hồi", nhom: "nhóm", loc: "lọc", ca: "cá", yt: "YouTube", fb: "Facebook",
  trich: "trích", phan: "phản", nhan: "nhân", hoi: "hồi", ho: "hồ", dong: "đóng", chon: "chọn", tl: "trả lời", khong: "không", ghi: "ghi",
  dem: "đếm", dan: "dẫn", cau: "câu", vong: "vòng", sang: "sang", ma: "mã", luan: "luận", kiem: "kiểm", da: "đã", binh: "bình", xuat: "xuất",
  them: "thêm", ten: "tên", short: "Short", shorts: "Shorts", qc: "quảng cáo", moi: "mới", khoa: "khoá", ke: "kế", goc: "gốc", dung: "dừng",
  de: "đề", cua: "của", cho: "chờ", vua: "vừa", ve: "về", toi: "tới", tin: "tin", tat: "tắt", tao: "tạo", tai: "tải", tac: "tác", sach: "sách",
  noi: "nội", nguoi: "người", lai: "lại", khoan: "khoản", khi: "khi", hop: "hộp", gia: "gia", ghim: "ghim", danh: "danh", cuon: "cuộn",
  chuyen: "chuyển", chu: "chữ", bang: "bảng", an: "ẩn", viet: "viết", lien: "liên", quan: "quan", chua: "chưa", tham: "tham", thu: "thử",
  giay: "giây", phut: "phút", ngay: "ngày", url: "địa chỉ", max: "nhiều nhất", min: "ít nhất", items: "mục", gian: "giãn", cach: "cách",
  dl: "đăng lại", td: "trích dẫn", tk: "tìm kiếm", dat: "đặt", ds: "danh sách",
  nhip: "nhịp", theo: "theo", doi: "đổi", dau: "đầu", suat: "suất", tan: "tần", lich: "lịch", sua: "sửa", xoa: "xoá",
};
/** Cụm hai/ba từ ghép cần dịch cả cụm (trước khi dịch từng từ). "tu tim" ở cuối mã = biến thể tự tìm → bỏ, không hiện. */
const CUM: [string[], string][] = [
  [["ca", "nhan"], "cá nhân"], [["phan", "hoi"], "phản hồi"], [["binh", "luan"], "bình luận"], [["tra", "loi"], "trả lời"], [["ho", "so"], "hồ sơ"],
  [["trich", "dan"], "trích dẫn"], [["bang", "tin"], "bảng tin"], [["tai", "khoan"], "tài khoản"], [["tat", "ca"], "tất cả"], [["danh", "sach"], "danh sách"], [["tham", "gia"], "tham gia"],
  [["ma", "goc"], "mã gốc"], [["tac", "gia"], "tác giả"], [["tan", "suat"], "tần suất"], [["dau", "ngay"], "đầu ngày"], [["lien", "quan"], "liên quan"],
  [["bai", "viet"], "bài viết"], [["khong", "ma"], "không mã"], [["so", "tra", "loi"], "số trả lời"],
];
/** Từ giữ nguyên dạng (trùng chính tả tiếng Việt / tên riêng) — không coi là "mã lọt ra". */
export const TU_GIU_NGUYEN = new Set(["x", "video", "nick", "menu", "tin", "khi", "short", "shorts", "trang", "ghim", "sang", "danh", "gia", "quan", "tham", "ghi", "theo", "xem"]);

const hoa1 = (s: string): string => (s ? s[0]!.toUpperCase() + s.slice(1) : s);

function dichTu(tokens: string[]): string {
  const out: string[] = [];
  for (let i = 0; i < tokens.length;) {
    let khop = false;
    for (const [c, vi] of CUM) {
      if (c.length <= tokens.length - i && c.every((t, k) => tokens[i + k] === t)) { out.push(vi); i += c.length; khop = true; break; }
    }
    if (khop) continue;
    const t = tokens[i]!;
    out.push(/^\d+$/.test(t) ? t : TU[t] ?? t);
    i++;
  }
  return out.join(" ");
}

/** Tên tiếng Việt của mã bước ("dang_bai_nhom" → "Đăng bài vào nhóm"). Bước lặp lại ("chon_bai_2") theo gốc + "(lần 2)". Không bao giờ trả mã có dấu gạch dưới. */
export function tenBuocVi(id: string): string {
  const ma = (id ?? "").trim();
  if (!ma) return "";
  if (Object.prototype.hasOwnProperty.call(TEN_BUOC_VI, ma)) return TEN_BUOC_VI[ma]!;
  const m = /^(.*?)_(\d+)$/.exec(ma);
  if (m && Object.prototype.hasOwnProperty.call(TEN_BUOC_VI, m[1]!)) return `${TEN_BUOC_VI[m[1]!]!} (lần ${m[2]})`;
  let tokens = ma.toLowerCase().split(/[_\-\s.]+/).filter(Boolean);
  if (tokens.length >= 2 && tokens[tokens.length - 2] === "tu" && tokens[tokens.length - 1] === "tim") tokens = tokens.slice(0, -2); // biến thể "tự tìm"
  return hoa1(dichTu(tokens));
}

const NHAN_PHU: Record<string, string> = {
  dau_ngay: "đầu ngày", tan_suat: "tần suất", n_ngay: "cách ngày", min_items: "số mục ít nhất", max_items: "số mục nhiều nhất",
  thoi_gian_giay: "Thời gian lướt (giây)", tu_phut: "Lướt từ (phút)", den_phut: "Lướt đến (phút)",
};
/** Nhãn người đọc của khoá tham số ("tu_phut" → "Lướt từ (phút)"). Khoá lạ → dịch từng từ, đuôi _giay/_phut thành (giây)/(phút). */
export function nhanThamSoVi(khoa: string): string {
  const k = (khoa ?? "").trim();
  if (!k) return "";
  if (Object.prototype.hasOwnProperty.call(NHAN_THAM_SO, k)) return NHAN_THAM_SO[k]!;
  if (Object.prototype.hasOwnProperty.call(NHAN_PHU, k)) return NHAN_PHU[k]!;
  const m = /^(.*)_(giay|phut)$/.exec(k);
  if (m) return `${hoa1(dichTu(m[1]!.toLowerCase().split("_")))} (${m[2] === "giay" ? "giây" : "phút"})`;
  return hoa1(dichTu(k.toLowerCase().split(/[_\-\s]+/).filter(Boolean)));
}

/** Mã đường/nhánh của lượt ("duong-n4" = đường bắt đầu từ ô n4) → "nhánh YouTube (bước 4)". Có `tenMang` → thêm tên mạng; số bước lấy từ `soBuoc` hoặc số trong mã ô; không rõ → "một nhánh". */
export function nhanNhanh(ma: string, bo: { tenMang?: string | null; soBuoc?: number | null } = {}): string {
  const m = /^duong-(.+)$/.exec((ma ?? "").trim());
  if (!m) return "";
  const so = bo.soBuoc ?? (/^[a-z]*(\d+)$/i.exec(m[1]!)?.[1] ? Number(/^[a-z]*(\d+)$/i.exec(m[1]!)![1]) : null);
  const mang = bo.tenMang ? ` ${bo.tenMang}` : "";
  if (so === null) return mang ? `nhánh${mang}` : "một nhánh";
  return `nhánh${mang} (bước ${so})`;
}

const RE_MA_BUOC = /(?<![\p{L}\p{N}_.:=#@-])([a-z][a-z0-9]*(?:_[a-z0-9]+)+)(?![\p{L}\p{N}_-]|\.\p{L})/gu;
const RE_NHANH = /(?<![\p{L}\p{N}_-])duong-([A-Za-z]*\d+|[A-Za-z0-9]+)(?![\p{L}\p{N}_-])/gu;

/** Làm sạch một câu do máy sinh ra trước khi hiện cho người dùng: mã tham số → nhãn, mã bước → tên bước, "duong-nX" → nhánh, múi giờ → "giờ Việt Nam".
 *  KHÔNG dùng cho chữ do người dùng gõ (tên, nội dung bài). `nhanh` cho phép nơi gọi (biết sơ đồ) trả "nhánh YouTube (bước 4)" thay cho dạng suy từ mã. */
export function lamSachMa(chu: string | null | undefined, bo: { nhanh?: (maDuong: string) => string | null } = {}): string {
  if (!chu) return "";
  // địa chỉ (http…) giữ nguyên: chỉ làm sạch các đoạn chữ ở giữa
  return chu.split(/(https?:\/\/\S+)/g).map((doan, i) => (i % 2 === 1 ? doan : lamSachDoan(doan, bo))).join("");
}
function lamSachDoan(chu: string, bo: { nhanh?: (maDuong: string) => string | null }): string {
  return chu
    .replace(/Asia\/Ho_Chi_Minh/g, "giờ Việt Nam")
    .replace(RE_NHANH, (nguyen) => bo.nhanh?.(nguyen) ?? nhanNhanh(nguyen))
    .replace(RE_MA_BUOC, (nguyen) => {
      if (Object.prototype.hasOwnProperty.call(NHAN_THAM_SO, nguyen) || Object.prototype.hasOwnProperty.call(NHAN_PHU, nguyen)) return nhanThamSoVi(nguyen).toLowerCase();
      return tenBuocVi(nguyen);
    });
}
